import { createBrowserRouter, redirect } from 'react-router-dom';
import { SecureRoute } from '@core/Okta';
import { BASE_URL } from '../../env';
import AuthorizationSecurity from '@core/roles/AuthorizationSecurity.jsx';

import {
  E_RECRUITMENT,
  E_SUB_ALL_ROLE_AGENCY,
  E_RECRUITMENT_AOS,
} from '@core/roles/RoleConstants.js';
import {
  ALL_CHANNEL,
  ACB_CHANNEL,
  TPB_CHANNEL,
  AGENCY_CHANNEL,
  CHECK_IN,
  ALL_CHANNEL_INDIVIDUAL,
  FEE,
  LEAD,
  SALES_PORTAL_PERSISTENCE_CHANNEL_MAP,
  SALES_PORTAL_ROLE_CODE_MAP,
  ALL_CHANNEL_MANAGER,
  FLAIR_CHANNEL_NON_BNK,
  FLAIR_CHANNEL_MANAGER,
  SALES_PORTAL_CHANNEL_MAP,
  ACB_NON_SALES,
  TRAJET_REPORT,
  AGENCY_CHANNEL_MANAGER,
} from '@core/roles/SalesPortalRoles.js';
import NonAuthLayout from '@components/layouts/NonAuthLayout';
import { isDateGreaterOrEqual } from '@helpers/dateUtils.js';

export const RoutePaths = {
  HOME: '/',
  CANDIDATE: '/candidate',
  LOGIN: '/login',
  DASHBOARD: '/dashboard',
  DASHBOARD_HOME: '/home',
  CHANGE_PASSWORD: '/change-password',
  FORCE_CHANGE_PASSWORD: '/force-change-password',
  TOP_PERFORMERS: '/top-performers',
  LIBRARIES: '/libraries',
  LIBRARIES_FORM: '/libraries/form',
  LIBRARIES_DETAIL: '/libraries/:details',
  LIBRARIES_NOTIFY: '/libraries/notify',
  LIBRARIES_INSTRUCTION: '/libraries/instruction',
  LIBRARIES_PROCESS: '/libraries/process',
  LIBRARIES_COMPETITION_PROGRAM: '/libraries/competition-program',
  LIBRARIES_PRODUCT_DOC: '/libraries/product-doc',
  K2_REPORT: '/k2-report',
  RECRUITMENT_PROGRESS_REPORT: '/recruitment-progress-report',
  OKTA: {
    CALLBACK_LOGIN: '/okta/sso-auth-login',
    CALLBACK_LOGOUT_LOCAL: '/okta/sso-auth-logout',
    CALLBACK_LOGOUT: '/okta/logout',
  },
  SERVICES: '/services',
  SERVICES_CUSTOMER: '/dashboard/customers',
  LIST_CLIENT: '/client',
  CLIENT_DETAIL: '/client/:details',
  FEE: '/dashboard/fee',
  FEE_HISTORY: '/dashboard/fee-history',
  FEE_HISTORY_DETAIL: '/dashboard/fee-history/:details',
  POLICY_LIST: '/policy/policy-list',
  POLICY_DETAIL: '/policy/policy-detail/:details',
  TEAM_POLICY: '/policy/team-policy-list',
  MY_PROFILE: '/dashboard/profile',
  MY_PROFILE_DETAIL: '/profile/:details',
  INFORMATION: '/information',
  REQUEST_ONLINE: '/request-online',
  E_REQUEST_TERMINATE_BANCA_SUBMIT: '/e-request/terminate/banca/submit',
  E_REQUEST_TERMINATE_BANCA_DETAIL:
    '/e-request/terminate/banca/detail/:requestNumber',
  E_REQUEST_TERMINATE_BANCA_REVIEW:
    '/e-request/terminate/banca/review/:requestNumber',
  E_REQUEST_TERMINATE_BANCA_HAND_OVER:
    '/e-request/terminate/banca/hand-over/:requestNumber',
  E_REQUEST_TERMINATE_AGENCY_SUBMIT: '/e-request/terminate/agency/submit',
  E_REQUEST_TERMINATE_AGENCY_REVIEW:
    '/e-request/terminate/agency/review/:requestNumber',
  E_REQUEST_TERMINATE_AGENCY_DETAIL:
    '/e-request/terminate/agency/detail/:requestNumber',
  E_REQUEST_LEAVE_SUBMIT: '/e-request/leave/submit',
  E_REQUEST_LEAVE_DETAIL: '/e-request/leave/details',
  E_REQUEST_BACKUP_BANCA_SUBMIT: '/e-request/backup/banca/submit',
  E_REQUEST_BACKUP_BANCA_DETAIL:
    '/e-request/backup/banca/detail/:requestNumber',
  E_REQUEST_BACKUP_BANCA_REVIEW:
    '/e-request/backup/banca/review/:requestNumber',
  E_REQUEST_BACKUP_BANCA_UPDATE:
    '/e-request/backup/banca/update/:requestNumber',
  ADD_DOC_UPLOAD_HISTORY: '/dashboard/add-doc-upload-history',
  E_RECRUITMENT: '/e-recruitment',
  E_RECRUITMENT_NEW: '/e-recruitment/new',
  E_RECRUITMENT_SEARCH: '/e-recruitment/search',
  E_RECRUITMENT_DETAILS: '/e-recruitment/details',
  E_RECRUITMENT_HOLIDAYS: '/e-recruitment/holidays',
  E_RECRUITMENT_CANDIDATE_LIST: '/e-recruitment/candidate-list',
  E_RECRUITMENT_PRE_CANDIDATE: '/precandidate',
  E_RECRUITMENT_FLAIR_PRE_CANDIDATE: '/flair-precandidate',

  E_PROMOTION: '/e-promotion',
  E_PROMOTION_NEW: '/e-promotion/new',
  E_PROMOTION_SEARCH: '/e-promotion/search',
  E_PROMOTION_AM_CANDIDATE: '/e-promotion',
  E_PROMOTION_DETAILS: '/e-promotion/details',

  NOT_FOUND: '**',
  SALE_REPORT: '/sale-report',
  E_RECOGNITION_LIST: '/e-recognition/list',
  E_RECOGNITION_DETAIL: '/e-recognition/detail/:agentCode',
  POLICY: '/sale-repoprt/policy',
  POLICY_SEARCH: '/sale-repoprt/policy/policy-search',
  BANCA_ACB_SURVEY: '/survey/acb',
  SELECT_ROLES: '/select-roles',
  SALES_REPORT: '/sales-report',
  TRAJET_REPORT: '/trajet-report',
  LEAD_HISTORY_DETAILS: '/lead-history/:details',

  // PAYSLIP
  SALE_REPORT_HOUSEHOLD_PAYSLIP: '/sale-report/household-payslip',
  SALE_REPORT_NONE_HOUSEHOLD_PAYSLIP: '/sale-report/payslip',

  // FORGET PASSWORD
  FORGET_PASSWORD: '/forget-password',
  CHECK_IN: '/check-in',
  LEAD: '/lead',
  CLIENT_CARE_ACTIVITY: '/client/client-care-activity',
  CLIENT_CARE_HISTORY: '/client/client-care-history/:clientId',
  UPDATE_CLIENT_CARE: '/client/update-client-care/:clientId',
  UPDATE_CLIENTS_CARE: '/client/update-clients-care',
  LEAD_ACTIVITY_LIST: '/trajet-report/activity-list/:leadId',
  LEAD_HISTORY: '/lead/history',
  OPM_CONTRACT_TRANSFER: '/opm/policy-transfer',
  OPM_UPDATE_ADVISOR: '/opm/policy-transfer/update-advisor',
  OPM_AD_ASSIGN: '/opm/policy-transfer/ad-assign',
  INCOME_TOOL: '/libraries/income-tool',
  INCOME_TOOL_ACB: '/libraries/income-tool-acb',
  INCOME_TOOL_TPB: '/libraries/income-tool-tpb',
};

export const PublicRoutes = [
  RoutePaths.LOGIN,
  RoutePaths.E_RECRUITMENT_PRE_CANDIDATE,
  RoutePaths.E_RECRUITMENT_FLAIR_PRE_CANDIDATE,
  RoutePaths.MY_PROFILE_DETAIL.replace(':details', ''),
];

export const SecurityPathConfig = {
  REQUEST_ONLINE: {
    scopes: [ALL_CHANNEL],
  },
  MY_PROFILE: {
    scopes: [ALL_CHANNEL],
  },
  FEE: {
    scopes: [FEE],
  },
  K2_REPORT: {
    scopes: [ALL_CHANNEL, [ACB_NON_SALES]],
  },
  E_RECOGNITION: {
    scopes: [ALL_CHANNEL],
  },
  CLIENT: {
    scopes: [ALL_CHANNEL_INDIVIDUAL],
  },
  TEAM_POLICY_LIST: {
    scopes: [ALL_CHANNEL_MANAGER],
  },
  COMMON_HOUSEHOLD_PAYSLIP: {
    scopes: [AGENCY_CHANNEL_MANAGER],
  },
  NONE_HOUSEHOLD_PAYSLIP: {
    scopes: [ALL_CHANNEL],
  },
  POLICY_SEARCH: {
    scopes: [ALL_CHANNEL_INDIVIDUAL],
  },
  POLICY_INDIVIDUAL: {
    scopes: [ALL_CHANNEL_INDIVIDUAL],
  },
  SURVEY: {
    scope: [ACB_CHANNEL],
  },
  CHECK_IN: {
    scopes: [CHECK_IN],
  },
  SALES_REPORT: {
    scopes: [ALL_CHANNEL, [ACB_NON_SALES]],
  },
  RECRUITMENT_PROGRESS_REPORT: {
    scopes: [AGENCY_CHANNEL_MANAGER],
  },
  LEAD: {
    scopes: [LEAD],
  },
  CLIENT_CARE: {
    scopes: [ALL_CHANNEL_INDIVIDUAL],
  },
  TRAJET_REPORT: {
    scopes: [TRAJET_REPORT],
  },
  OPM_CONTRACT_TRANSFER: {
    scopes: [ALL_CHANNEL_MANAGER],
  },
  E_REQUEST_TERMINATE_BANCA: {
    scopes: [FLAIR_CHANNEL_NON_BNK],
  },
  E_REQUEST_TERMINATE_AGENCY: {
    scopes: [AGENCY_CHANNEL],
  },
  E_REQUEST_LEAVE: {
    scopes: [FLAIR_CHANNEL_NON_BNK],
  },
  E_REQUEST_BACKUP_BANCA: {
    scopes: [FLAIR_CHANNEL_MANAGER],
  },
};

export const router = createBrowserRouter(
  [
    {
      path: RoutePaths.OKTA.CALLBACK_LOGIN,
      lazy: () =>
        import('@pages/CallbackOkta').then((module) => ({
          Component: module.default,
        })),
    },
    {
      path: RoutePaths.OKTA.CALLBACK_LOGOUT_LOCAL,
      loader: () => {
        return redirect(RoutePaths.LOGIN);
      },
    },
    {
      path: RoutePaths.OKTA.CALLBACK_LOGOUT,
      loader: () => {
        return redirect(RoutePaths.LOGIN);
      },
    },
    {
      path: RoutePaths.LOGIN,
      lazy: () =>
        import('@pages/Auth').then((module) => ({
          Component: module.default,
        })),
    },
    {
      path: `${RoutePaths.FORGET_PASSWORD}`,
      lazy: () =>
        import('@pages/ForgetPassword').then((module) => ({
          Component: module.default,
        })),
    },
    {
      path: RoutePaths.MY_PROFILE_DETAIL,
      lazy: () =>
        import('@pages/MyProfile/Detail').then((module) => ({
          Component: module.default,
        })),
    },
    {
      path: RoutePaths.HOME,
      lazy: () =>
        import('@components/layouts/MainLayout').then((module) => ({
          element: <SecureRoute component={module.default} />,
        })),
      children: [
        {
          index: true,
          path: `${RoutePaths.SELECT_ROLES}/*`,
          lazy: () =>
            import('@pages/SelectRoles').then((module) => ({
              Component: module.default,
            })),
        },
        {
          index: true,
          path: `${RoutePaths.CHANGE_PASSWORD}/*`,
          lazy: () =>
            import('@pages/ChangePassword').then((module) => ({
              Component: module.default,
            })),
        },
        {
          index: true,
          path: `${RoutePaths.FORCE_CHANGE_PASSWORD}/*`,
          lazy: () =>
            import('@pages/ChangePassword').then((module) => ({
              Component: module.default,
            })),
        },
        {
          index: true,
          path: `${RoutePaths.DASHBOARD_HOME}/*`,
          lazy: () =>
            import('@pages/DashboardHome').then((module) => ({
              Component: module.default,
            })),
        },
        {
          index: true,
          path: `${RoutePaths.LIBRARIES_FORM}/*`,
          lazy: () =>
            import('@pages/Libraries/LibrariesForm').then((module) => ({
              Component: module.default,
            })),
        },
        {
          index: true,
          path: `${RoutePaths.INCOME_TOOL}/*`,
          lazy: () =>
            import('@pages/ERecruitment/Income/incomeTool').then((module) => ({
              Component: module.default,
            })),
        },
        {
          path: `${RoutePaths.INCOME_TOOL_ACB}/*`,
          lazy: () =>
            import('@pages/ERecruitment/Income/incomeToolACB').then(
              (module) => ({
                Component: module.default,
              }),
            ),
        },
        {
          path: `${RoutePaths.INCOME_TOOL_TPB}/*`,
          lazy: () =>
            import('@pages/ERecruitment/Income/incomeToolTPB').then(
              (module) => ({
                Component: module.default,
              }),
            ),
        },
        {
          path: `${RoutePaths.LIBRARIES_DETAIL}/*`,
          lazy: () =>
            import('@pages/Libraries/LibrariesDetail').then((module) => ({
              Component: module.default,
            })),
        },
        {
          path: `${RoutePaths.LIBRARIES_NOTIFY}/*`,
          lazy: () =>
            import('@pages/Libraries/LibrariesNotify').then((module) => ({
              Component: module.default,
            })),
        },
        {
          path: `${RoutePaths.LIBRARIES_INSTRUCTION}/*`,
          lazy: () =>
            import('@pages/Libraries/LibrariesInstruction').then((module) => ({
              Component: module.default,
            })),
        },
        {
          path: `${RoutePaths.LIBRARIES_PROCESS}/*`,
          lazy: () =>
            import('@pages/Libraries/LibrariesProcess').then((module) => ({
              Component: module.default,
            })),
        },
        {
          path: `${RoutePaths.LIBRARIES_COMPETITION_PROGRAM}/*`,
          lazy: () =>
            import('@pages/Libraries/LibrariesCompetitionProgram').then(
              (module) => ({
                Component: module.default,
              }),
            ),
        },
        {
          path: `${RoutePaths.LIBRARIES_PRODUCT_DOC}/*`,
          lazy: () =>
            import('@pages/Libraries/LibrariesProductDoc').then((module) => ({
              Component: module.default,
            })),
        },
        {
          path: `${RoutePaths.K2_REPORT_POLICY_DETAIL}/*`,
          lazy: () =>
            import('@pages/K2Report/PolicyDetail').then((module) => ({
              element: (
                <AuthorizationSecurity
                  scopes={SecurityPathConfig.K2_REPORT_POLICY_DETAIL.scopes}
                  component={module.default}
                />
              ),
            })),
        },
        {
          path: `${RoutePaths.INFORMATION}/*`,
          lazy: () =>
            import('@pages/MyProfile/Infomation').then((module) => ({
              element: (
                <AuthorizationSecurity
                  scopes={SecurityPathConfig.MY_PROFILE.scopes}
                  component={module.default}
                />
              ),
            })),
        },
        {
          path: `${RoutePaths.REQUEST_ONLINE}/*`,
          lazy: () =>
            import('@pages/MyProfile/RequestOnline').then((module) => ({
              element: (
                <AuthorizationSecurity
                  scopes={SecurityPathConfig.REQUEST_ONLINE.scopes}
                  component={module.default}
                  channelMap={SALES_PORTAL_CHANNEL_MAP}
                />
              ),
            })),
        },
        {
          path: `${RoutePaths.E_REQUEST_TERMINATE_BANCA_SUBMIT}/*`,
          lazy: () =>
            import('@pages/ERequest/Terminate/Banca').then((module) => ({
              element: (
                <AuthorizationSecurity
                  channelMap={SALES_PORTAL_PERSISTENCE_CHANNEL_MAP}
                  profileCodeMap={SALES_PORTAL_ROLE_CODE_MAP}
                  scopes={SecurityPathConfig.E_REQUEST_TERMINATE_BANCA.scopes}
                  component={module.default}
                />
              ),
            })),
        },
        {
          path: `${RoutePaths.E_REQUEST_TERMINATE_BANCA_DETAIL}/*`,
          lazy: () =>
            import('@pages/ERequest/Terminate/Banca').then((module) => ({
              element: (
                <AuthorizationSecurity
                  channelMap={SALES_PORTAL_PERSISTENCE_CHANNEL_MAP}
                  profileCodeMap={SALES_PORTAL_ROLE_CODE_MAP}
                  scopes={SecurityPathConfig.E_REQUEST_TERMINATE_BANCA.scopes}
                  component={module.default}
                />
              ),
            })),
        },
        {
          path: `${RoutePaths.E_REQUEST_TERMINATE_BANCA_REVIEW}/*`,
          lazy: () =>
            import('@pages/ERequest/Terminate/Banca').then((module) => ({
              element: (
                <AuthorizationSecurity
                  channelMap={SALES_PORTAL_PERSISTENCE_CHANNEL_MAP}
                  profileCodeMap={SALES_PORTAL_ROLE_CODE_MAP}
                  scopes={SecurityPathConfig.E_REQUEST_TERMINATE_BANCA.scopes}
                  component={module.default}
                />
              ),
            })),
        },
        {
          path: `${RoutePaths.E_REQUEST_TERMINATE_BANCA_HAND_OVER}/*`,
          lazy: () =>
            import('@pages/ERequest/Terminate/Banca').then((module) => ({
              element: (
                <AuthorizationSecurity
                  channelMap={SALES_PORTAL_PERSISTENCE_CHANNEL_MAP}
                  profileCodeMap={SALES_PORTAL_ROLE_CODE_MAP}
                  scopes={SecurityPathConfig.E_REQUEST_TERMINATE_BANCA.scopes}
                  component={module.default}
                />
              ),
            })),
        },
        {
          path: `${RoutePaths.E_REQUEST_TERMINATE_AGENCY_SUBMIT}/*`,
          lazy: () =>
            import('@pages/ERequest/Terminate/NonBanca').then((module) => ({
              element: (
                <AuthorizationSecurity
                  scopes={SecurityPathConfig.E_REQUEST_TERMINATE_AGENCY.scopes}
                  component={module.default}
                />
              ),
            })),
        },
        {
          path: `${RoutePaths.E_REQUEST_TERMINATE_AGENCY_REVIEW}/*`,
          lazy: () =>
            import('@pages/ERequest/Terminate/NonBanca').then((module) => ({
              element: (
                <AuthorizationSecurity
                  scopes={SecurityPathConfig.E_REQUEST_TERMINATE_AGENCY.scopes}
                  component={module.default}
                />
              ),
            })),
        },
        {
          path: `${RoutePaths.E_REQUEST_TERMINATE_AGENCY_DETAIL}/*`,
          lazy: () =>
            import('@pages/ERequest/Terminate/NonBanca').then((module) => ({
              element: (
                <AuthorizationSecurity
                  scopes={SecurityPathConfig.E_REQUEST_TERMINATE_AGENCY.scopes}
                  component={module.default}
                />
              ),
            })),
        },
        {
          path: `${RoutePaths.E_REQUEST_LEAVE_SUBMIT}/*`,
          lazy: () =>
            import('@pages/ERequest/Leave').then((module) => ({
              element: (
                <AuthorizationSecurity
                  scopes={SecurityPathConfig.E_REQUEST_LEAVE.scopes}
                  component={module.default}
                />
              ),
            })),
        },
        {
          path: `${RoutePaths.E_REQUEST_LEAVE_DETAIL}/*`,
          lazy: () =>
            import('@pages/ERequest/Leave').then((module) => ({
              element: (
                <AuthorizationSecurity
                  channelMap={SALES_PORTAL_PERSISTENCE_CHANNEL_MAP}
                  profileCodeMap={SALES_PORTAL_ROLE_CODE_MAP}
                  scopes={SecurityPathConfig.E_REQUEST_LEAVE.scopes}
                  component={module.default}
                />
              ),
            })),
        },
        {
          path: `${RoutePaths.E_REQUEST_BACKUP_BANCA_SUBMIT}/*`,
          lazy: () =>
            import('@pages/ERequest/Backup/Banca').then((module) => ({
              element: (
                <AuthorizationSecurity
                  channelMap={SALES_PORTAL_PERSISTENCE_CHANNEL_MAP}
                  profileCodeMap={SALES_PORTAL_ROLE_CODE_MAP}
                  scopes={SecurityPathConfig.E_REQUEST_BACKUP_BANCA.scopes}
                  component={module.default}
                />
              ),
            })),
        },
        {
          path: `${RoutePaths.E_REQUEST_BACKUP_BANCA_REVIEW}/*`,
          lazy: () =>
            import('@pages/ERequest/Backup/Banca').then((module) => ({
              element: (
                <AuthorizationSecurity
                  channelMap={SALES_PORTAL_PERSISTENCE_CHANNEL_MAP}
                  profileCodeMap={SALES_PORTAL_ROLE_CODE_MAP}
                  scopes={SecurityPathConfig.E_REQUEST_BACKUP_BANCA.scopes}
                  component={module.default}
                />
              ),
            })),
        },
        {
          path: `${RoutePaths.E_REQUEST_BACKUP_BANCA_DETAIL}/*`,
          lazy: () =>
            import('@pages/ERequest/Backup/Banca').then((module) => ({
              element: (
                <AuthorizationSecurity
                  channelMap={SALES_PORTAL_PERSISTENCE_CHANNEL_MAP}
                  profileCodeMap={SALES_PORTAL_ROLE_CODE_MAP}
                  scopes={SecurityPathConfig.E_REQUEST_BACKUP_BANCA.scopes}
                  component={module.default}
                />
              ),
            })),
        },
        {
          path: `${RoutePaths.E_REQUEST_BACKUP_BANCA_UPDATE}/*`,
          lazy: () =>
            import('@pages/ERequest/Backup/Banca').then((module) => ({
              element: (
                <AuthorizationSecurity
                  channelMap={SALES_PORTAL_PERSISTENCE_CHANNEL_MAP}
                  profileCodeMap={SALES_PORTAL_ROLE_CODE_MAP}
                  scopes={SecurityPathConfig.E_REQUEST_BACKUP_BANCA.scopes}
                  component={module.default}
                />
              ),
            })),
        },
        {
          path: `${RoutePaths.LIST_CLIENT}/*`,
          lazy: () =>
            import('@pages/Client').then((module) => ({
              element: (
                <AuthorizationSecurity
                  scopes={SecurityPathConfig.CLIENT.scopes}
                  component={module.default}
                />
              ),
            })),
        },
        {
          path: `${RoutePaths.CLIENT_DETAIL}`,
          lazy: () =>
            import('@pages/Client/ClientDetail').then((module) => ({
              element: (
                <AuthorizationSecurity
                  scopes={SecurityPathConfig.CLIENT.scopes}
                  component={module.default}
                />
              ),
            })),
        },
        ...(!isDateGreaterOrEqual(1, 1, 2026)
          ? [
              {
                path: `${RoutePaths.FEE}/*`,
                lazy: () =>
                  import('@pages/Fee').then((module) => ({
                    element: (
                      <AuthorizationSecurity
                        scopes={SecurityPathConfig.FEE.scopes}
                        component={module.default}
                      />
                    ),
                  })),
              },
            ]
          : []),
        {
          path: `${RoutePaths.FEE_HISTORY}/*`,
          lazy: () =>
            import('@pages/Fee/FeeHistory').then((module) => ({
              element: (
                <AuthorizationSecurity
                  scopes={SecurityPathConfig.FEE.scopes}
                  component={module.default}
                />
              ),
            })),
        },
        {
          path: `${RoutePaths.FEE_HISTORY_DETAIL}/*`,
          lazy: () =>
            import('@pages/Fee/FeeHistoryDetail').then((module) => ({
              element: (
                <AuthorizationSecurity
                  scopes={SecurityPathConfig.FEE.scopes}
                  component={module.default}
                />
              ),
            })),
        },
        {
          path: `${RoutePaths.POLICY_LIST}`,
          lazy: () =>
            import('@pages/Policy/IndividualPolicy').then((module) => ({
              element: (
                <AuthorizationSecurity
                  scopes={SecurityPathConfig.POLICY_INDIVIDUAL.scopes}
                  component={module.default}
                />
              ),
            })),
        },
        {
          path: `${RoutePaths.POLICY_DETAIL}`,
          lazy: () =>
            import('@pages/Policy/PolicyDetail').then((module) => ({
              element: (
                <AuthorizationSecurity
                  scopes={SecurityPathConfig.POLICY_INDIVIDUAL.scopes}
                  component={module.default}
                />
              ),
            })),
        },
        {
          path: `${RoutePaths.ADD_DOC_UPLOAD_HISTORY}/*`,
          lazy: () =>
            import('@pages/Policy/AddDocUploadHistory').then((module) => ({
              Component: module.default,
            })),
        },
        {
          path: RoutePaths.E_RECRUITMENT_NEW,
          lazy: () =>
            import('@pages/ERecruitment/NewForChannel').then((module) => ({
              Component: module.default,
            })),
        },
        {
          path: `${RoutePaths.E_RECRUITMENT_DETAILS}`,
          lazy: () =>
            import('@pages/ERecruitment/DetailForChannel').then((module) => ({
              Component: module.default,
            })),
        },
        {
          path: `${RoutePaths.E_RECRUITMENT_SEARCH}`,
          lazy: () =>
            import('@pages/ERecruitment/Search').then((module) => ({
              element: (
                <AuthorizationSecurity
                  scopes={E_RECRUITMENT}
                  component={module.default}
                />
              ),
            })),
        },
        {
          path: `${RoutePaths.E_RECRUITMENT_CANDIDATE_LIST}`,
          lazy: () =>
            import('@pages/ERecruitment/CandidateList').then((module) => ({
              element: (
                <AuthorizationSecurity
                  scopes={E_RECRUITMENT}
                  component={module.default}
                />
              ),
            })),
        },
        {
          path: `${RoutePaths.E_RECRUITMENT_HOLIDAYS}`,
          lazy: () =>
            import('@pages/ERecruitment/HolidayCalendar').then((module) => ({
              element: (
                <AuthorizationSecurity
                  scopes={E_RECRUITMENT_AOS}
                  component={module.default}
                />
              ),
            })),
        },
        {
          path: RoutePaths.E_PROMOTION_NEW,
          lazy: () =>
            import('@pages/EPromotion/NewForChannel').then((module) => ({
              Component: module.default,
            })),
        },
        {
          path: `${RoutePaths.E_PROMOTION_DETAILS}`,
          lazy: () =>
            import('@pages/EPromotion/DetailForChannel').then((module) => ({
              Component: module.default,
            })),
        },
        {
          path: `${RoutePaths.E_PROMOTION_SEARCH}`,
          lazy: () =>
            import('@pages/EPromotion/Search').then((module) => ({
              element: (
                <AuthorizationSecurity
                  scopes={E_SUB_ALL_ROLE_AGENCY}
                  component={module.default}
                />
              ),
            })),
        },
        {
          path: `${RoutePaths.E_RECOGNITION_LIST}`,
          lazy: () =>
            import('@pages/ERecognition/List').then((module) => ({
              element: (
                <AuthorizationSecurity
                  scopes={SecurityPathConfig.E_RECOGNITION.scopes}
                  component={module.default}
                />
              ),
            })),
        },
        {
          path: `${RoutePaths.E_RECOGNITION_DETAIL}`,
          lazy: () =>
            import('@pages/ERecognition/Detail').then((module) => ({
              element: (
                <AuthorizationSecurity
                  scopes={SecurityPathConfig.E_RECOGNITION.scopes}
                  component={module.default}
                />
              ),
            })),
        },
        // START PAYSLIP
        {
          path: `${RoutePaths.SALE_REPORT_HOUSEHOLD_PAYSLIP}`,
          lazy: () =>
            import('@pages/Payslip/HouseholdPayslip').then((module) => ({
              element: (
                <AuthorizationSecurity
                  scopes={SecurityPathConfig.COMMON_HOUSEHOLD_PAYSLIP.scopes}
                  component={module.default}
                  specialCheck={'household'}
                />
              ),
            })),
        },
        {
          path: `${RoutePaths.SALE_REPORT_NONE_HOUSEHOLD_PAYSLIP}`,
          lazy: () =>
            import('@pages/Payslip/NoneHouseholdPayslip').then((module) => ({
              element: (
                <AuthorizationSecurity
                  scopes={SecurityPathConfig.NONE_HOUSEHOLD_PAYSLIP.scopes}
                  component={module.default}
                />
              ),
            })),
        },
        // END PAYSLIP
        {
          path: `${RoutePaths.CHECK_IN}`,
          lazy: () =>
            import('@pages/CheckIn/index.jsx').then((module) => ({
              element: (
                <AuthorizationSecurity
                  scopes={SecurityPathConfig.CHECK_IN.scopes}
                  component={module.default}
                />
              ),
            })),
        },
        {
          path: `${RoutePaths.POLICY_SEARCH}`,
          lazy: () =>
            import('@pages/Policy/PolicySearch').then((module) => ({
              element: (
                <AuthorizationSecurity
                  scopes={SecurityPathConfig.POLICY_SEARCH.scopes}
                  component={module.default}
                />
              ),
            })),
        },
        {
          path: `${RoutePaths.TEAM_POLICY}/*`,
          lazy: () =>
            import('@pages/Policy/TeamPolicy').then((module) => ({
              element: (
                <AuthorizationSecurity
                  scopes={ALL_CHANNEL_MANAGER}
                  component={module.default}
                />
              ),
            })),
        },
        {
          path: `${RoutePaths.BANCA_ACB_SURVEY}`,
          lazy: () =>
            import('@pages/SurveyLink/Banca/SurveyLinkQuestion').then(
              (module) => ({
                element: (
                  <AuthorizationSecurity
                    scopes={SecurityPathConfig.SURVEY.scopes}
                    component={module.default}
                  />
                ),
              }),
            ),
        },
        // START REPORTING
        {
          path: `${RoutePaths.K2_REPORT}/*`,
          lazy: () =>
            import('@pages/K2Report').then((module) => ({
              element: (
                <AuthorizationSecurity
                  channelMap={SALES_PORTAL_PERSISTENCE_CHANNEL_MAP}
                  profileCodeMap={SALES_PORTAL_ROLE_CODE_MAP}
                  scopes={SecurityPathConfig.K2_REPORT.scopes}
                  component={module.default}
                />
              ),
            })),
        },
        {
          path: `${RoutePaths.SALES_REPORT}/*`,
          lazy: () =>
            import('@pages/SalesReport').then((module) => ({
              element: (
                <AuthorizationSecurity
                  channelMap={SALES_PORTAL_PERSISTENCE_CHANNEL_MAP}
                  profileCodeMap={SALES_PORTAL_ROLE_CODE_MAP}
                  scopes={SecurityPathConfig.SALES_REPORT.scopes}
                  component={module.default}
                />
              ),
            })),
        },
        {
          path: `${RoutePaths.RECRUITMENT_PROGRESS_REPORT}/*`,
          lazy: () =>
            import('@pages/RecruitmentProgressReport').then((module) => ({
              element: (
                <AuthorizationSecurity
                  scopes={SecurityPathConfig.RECRUITMENT_PROGRESS_REPORT.scopes}
                  component={module.default}
                />
              ),
            })),
        },
        {
          path: `${RoutePaths.TRAJET_REPORT}/*`,
          lazy: () =>
            import('@pages/TrajetReport').then((module) => ({
              element: (
                <AuthorizationSecurity
                  profileCodeMap={SALES_PORTAL_ROLE_CODE_MAP}
                  scopes={SecurityPathConfig.TRAJET_REPORT.scopes}
                  component={module.default}
                />
              ),
            })),
        },
        {
          path: `${RoutePaths.LEAD_HISTORY_DETAILS}`,
          lazy: () =>
            import('@pages/TrajetReport/LeadHistoryDetail').then((module) => ({
              element: <AuthorizationSecurity component={module.default} />,
            })),
        },
        // END REPORTING
        {
          path: `${RoutePaths.LEAD}`,
          lazy: () =>
            import('@pages/Lead/CreateLead').then((module) => ({
              element: (
                <AuthorizationSecurity
                  scopes={SecurityPathConfig.LEAD.scopes}
                  component={module.default}
                />
              ),
            })),
        },
        {
          path: `${RoutePaths.CLIENT_CARE_ACTIVITY}/*`,
          lazy: () =>
            import('@pages/ClientCare/ClientCareActivity').then((module) => ({
              element: (
                <AuthorizationSecurity
                  scopes={SecurityPathConfig.CLIENT_CARE.scopes}
                  component={module.default}
                />
              ),
            })),
        },
        {
          path: `${RoutePaths.CLIENT_CARE_HISTORY}`,
          lazy: () =>
            import('@pages/ClientCare/ClientCareHistory').then((module) => ({
              element: (
                <AuthorizationSecurity
                  scopes={SecurityPathConfig.CLIENT_CARE.scopes}
                  component={module.default}
                />
              ),
            })),
        },
        {
          path: `${RoutePaths.UPDATE_CLIENT_CARE}`,
          lazy: () =>
            import('@pages/ClientCare/UpdateClientCare').then((module) => ({
              element: (
                <AuthorizationSecurity
                  scopes={SecurityPathConfig.CLIENT_CARE.scopes}
                  component={module.default}
                />
              ),
            })),
        },
        {
          path: `${RoutePaths.UPDATE_CLIENTS_CARE}`,
          lazy: () =>
            import('@pages/ClientCare/UpdateListClientCare').then((module) => ({
              element: (
                <AuthorizationSecurity
                  scopes={SecurityPathConfig.CLIENT_CARE.scopes}
                  component={module.default}
                />
              ),
            })),
        },
        {
          path: `${RoutePaths.LEAD_ACTIVITY_LIST}`,
          lazy: () =>
            import('@pages/TrajetReport/LeadActivityList').then((module) => ({
              element: (
                <AuthorizationSecurity
                  scopes={SecurityPathConfig.TRAJET_REPORT.scopes}
                  component={module.default}
                />
              ),
            })),
        },
        {
          path: `${RoutePaths.LEAD_HISTORY}`,
          lazy: () =>
            import('@pages/Lead/LeadHistory').then((module) => ({
              element: (
                <AuthorizationSecurity
                  scopes={SecurityPathConfig.LEAD.scopes}
                  component={module.default}
                />
              ),
            })),
        },
        {
          path: `${RoutePaths.OPM_CONTRACT_TRANSFER}`,
          lazy: () =>
            import('@pages/opm').then((module) => ({
              element: (
                <AuthorizationSecurity
                  scopes={SecurityPathConfig.OPM_CONTRACT_TRANSFER.scopes}
                  component={module.default}
                />
              ),
            })),
        },
        {
          path: RoutePaths.OPM_UPDATE_ADVISOR,
          lazy: () =>
            import('@pages/opm/UpdateAdvisorPage').then((module) => ({
              element: (
                <AuthorizationSecurity
                  scopes={SecurityPathConfig.OPM_CONTRACT_TRANSFER.scopes}
                  component={module.default}
                />
              ),
            })),
        },
        {
          path: RoutePaths.OPM_AD_ASSIGN,
          lazy: () =>
            import('@pages/opm/ADAssignAdvisorPage').then((module) => ({
              element: (
                <AuthorizationSecurity
                  scopes={SecurityPathConfig.OPM_CONTRACT_TRANSFER.scopes}
                  component={module.default}
                />
              ),
            })),
        },
      ],
    },
    {
      path: `${RoutePaths.E_RECRUITMENT_PRE_CANDIDATE}/:pCanId/:lastTransactionId`,
      lazy: () =>
        import('@pages/ERecruitment/Agency/OTPCandidate').then((module) => ({
          element: <NonAuthLayout component={module.default} />,
        })),
    },
    {
      path: `${RoutePaths.E_RECRUITMENT_FLAIR_PRE_CANDIDATE}/:pCanId`,
      lazy: () =>
        import('@pages/ERecruitment/Flair/OTPCandidate').then((module) => ({
          element: <NonAuthLayout component={module.default} />,
        })),
    },

    {
      path: `${RoutePaths.E_PROMOTION_AM_CANDIDATE}/:pAMId`,
      lazy: () =>
        import(
          '@pages/EPromotion/Agency/EProDetailsForRoles/Candidate/OTPCandidate'
        ).then((module) => ({
          element: <NonAuthLayout component={module.default} />,
        })),
    },
    {
      path: '*',
      lazy: () =>
        import('@pages/NotFound').then((module) => ({
          Component: module.default,
        })),
    },
  ],
  {
    basename: BASE_URL,
  },
);
